module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor06.aee22adc.png";